import React from 'react';

import { BottomSheet, Divider, Text } from '@thefarmersfront/kitchen-mobile';
import clsx from 'clsx';

import { BankLogoImage } from '~/components/shared';

import styles from './ConfirmBottomSheet.module.scss';

/** @description 제출 전 선택한 정보를 확인하는 바텀시트 */
const ConfirmBottomSheet = ({
  className,
  id,
  open,
  onClose,
  onConfirm,
  title,
  contents,
}: {
  className?: string;
  id: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  contents: { label: string; value: React.ReactNode; imageUrl?: string; hasDivider?: boolean }[];
}) => {
  return (
    <BottomSheet
      id={id}
      title={title}
      showHandbar={false}
      open={open}
      onClose={onClose}
      buttonConfig={{
        buttonType: 'confirm',
        buttonOrientation: 'horizontal',
        confirmText: '등록',
        cancelText: '취소',
        cancelColor: 'tertiary',
        cancelVariant: 'contained',
        onCancel: onClose,
        onConfirm: () => {
          onClose();
          onConfirm();
        },
      }}
    >
      <div className={clsx(styles['confirm-bottom-sheet-content'], className)}>
        {contents.map((item) => (
          <React.Fragment key={item.label}>
            <div className={styles['confirm-bottom-sheet-content-item']}>
              <Text className={styles['item-label']} color="secondary" size="xlarge">
                {item.label}
              </Text>
              <Text className={styles['item-value']} size="xlarge">
                {item.imageUrl && <BankLogoImage bankCode={item.imageUrl} />}
                {item.value}
              </Text>
            </div>
            {item.hasDivider && <Divider color="gray100" className={styles['divider']} />}
          </React.Fragment>
        ))}
      </div>
    </BottomSheet>
  );
};

export default ConfirmBottomSheet;
